import { Button, Empty, List, ListProps } from 'antd'
import { Dispatch, FC, ReactNode, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { DeleteOutlined } from '@ant-design/icons'

import { ScrapFile } from '../../types'

interface RemoveItemProps {
  fileList: ScrapFile[] | undefined
  setFileList: Dispatch<SetStateAction<ScrapFile[] | undefined>>
  className?: string
  listProps?: ListProps<ScrapFile>
  customActions?: (item?: ScrapFile) => ReactNode[]
  description?: (item?: ScrapFile) => ReactNode
}

const UploadFileList: FC<RemoveItemProps> = ({
  listProps,
  setFileList,
  fileList,
  customActions,
  description,
  className,
}) => {
  const { t } = useTranslation()
  const handleDeleteFile = (item: ScrapFile) => {
    setFileList(prevFileList => {
      return prevFileList?.filter(file => file.uid !== item.uid)
    })
  }
  return (
    <List
      className={className}
      {...listProps}
      dataSource={fileList}
      itemLayout="horizontal"
      locale={{
        emptyText: <Empty description={t('no_data_found')} />,
      }}
      renderItem={(item: ScrapFile, index: number) => (
        <List.Item
          key={item.uid + '-item-' + index}
          actions={[
            ...(customActions ? customActions(item) : []),
            <Button
              key={item.uid + '-delete-' + index}
              icon={<DeleteOutlined />}
              size="small"
              onClick={() => {
                handleDeleteFile(item)
              }}
            />,
          ]}
        >
          <List.Item.Meta
            key={item.uid + '-desc-' + index}
            description={description && description(item)}
            title={item.name}
          />
        </List.Item>
      )}
    />
  )
}

export default UploadFileList
